export default __webpack_public_path__ + "static/media/1327.09bcef3c.png";